import React from 'react';

import styled, { withTheme } from 'styled-components/macro';

import { AppBar as MuiAppBar, Grid, Toolbar } from '@material-ui/core';

import LogoFacilita from '../facilita-juridico-logo.png'

const AppBar = styled(MuiAppBar)`
    background: ${(props) => props.theme.header.background};
    color: ${(props) => props.theme.header.color};
    height: 50px;
`;

const ExternalRegisterHeader = () => (
    <React.Fragment>
        <AppBar position='fixed' elevation={0} className=' bg-[#376fd0] flex items-center justify-center !min-h-[64px]'>
            <Toolbar>
                <Grid className='flex flex-row justify-between w-full items-center'>
                    <Grid>
                        <div>
                            <div className="fixed top-0 left-[25px] h-[75px] max-w-[210px] bg-white z-[1101] rounded-b-lg shadow-[0_0_6px_rgba(0,0,0,0.4)]">
                                <div className='flex items-center justify-center'>
                                    <div className='max-h-full max-w-full'>
                                        <div className='h-[75px] p-2 max-w-full'>
                                            <img
                                                src={LogoFacilita}
                                                alt="Logo Facilita Jurídico"
                                                className="max-h-full"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    </React.Fragment>
);

export default withTheme(ExternalRegisterHeader);
